import { Common, ApiBind } from './common.model';

export class OSGroupOS extends Common {
  @ApiBind({ column: 'os_id' })
  id: number;
}
